/* eslint-disable react-hooks/exhaustive-deps */
'use client';

import { observer } from 'mobx-react';
import { useEffect } from 'react';
import { getStore } from '~/mobx/AppStore';
import SlagSettingsDetails from './SlagSettingsDetails';

const SlagSettingsWithStore = () => {
    const { generalSettingsStore, companyStore } = getStore();
    const { selectedCompany } = companyStore;
    const {
        electionList = [],
        isSettingsDisabled,
        isLoadingElectionList,
        preSelectElectionId,
        selectedElectionData,
        selectedElectionId,
        slagDescription,
        slagHowToVote,
        handleChangeElectionAttribute,
        handleUpdateElection,
        updateElectionData,
        setElectionData,
        setPreSelectElectionId,
        setSlagDescription,
        setSlagHowToVote,
    } = generalSettingsStore;

    useEffect(() => {
        setElectionData();
    }, [selectedElectionId, selectedElectionData]);

    return (
        <SlagSettingsDetails
            companyData={selectedCompany}
            electionList={electionList}
            isSettingsDisabled={isSettingsDisabled}
            isLoadingElectionList={isLoadingElectionList}
            preSelectElectionId={preSelectElectionId}
            selectedElectionData={selectedElectionData}
            slagDescription={slagDescription}
            slagHowToVote={slagHowToVote}
            handleUpdateElection={handleUpdateElection}
            handleChangeElectionAttribute={handleChangeElectionAttribute}
            updateElectionData={updateElectionData}
            setPreSelectElectionId={setPreSelectElectionId}
            setSlagDescription={setSlagDescription}
            setSlagHowToVote={setSlagHowToVote}
        />
    );
};

export default observer(SlagSettingsWithStore);
